import { ADDRESS_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/AddressStep/constants';
import { PREFERENCES_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/PreferencesStep/constants';
import { PASSWORD_CHANGE_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/ChangePhaseStep/components/PasswordChangeStep/constants';
import { RETAIL_PIN_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/common/steps/PinStep/constants';
import { RETAIL_PERSONAL_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailReg/steps/PersonalStep/constants';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

import { TRetailRegData, TRetailRegSteps } from './types';

export const RETAIL_REG_DATA: TRetailRegData = {
    [STEP_NAMES.PERSONAL_RETAIL_STEP]: RETAIL_PERSONAL_DATA,
    [STEP_NAMES.ADDRESS_RETAIL_STEP]: {
        ...ADDRESS_DATA,
        [VALIDATION_FIELDS.phone]: ''
    },
    [STEP_NAMES.PIN_RETAIL_STEP]: RETAIL_PIN_DATA,
    [STEP_NAMES.PASSWORD_RETAIL_STEP]: PASSWORD_CHANGE_DATA,
    [STEP_NAMES.PREFERENCES_RETAIL_STEP]: {
        ...PREFERENCES_DATA,
        [VALIDATION_FIELDS.terms]: false
    }
};

export const RETAIL_REG_ORDERED_STEPS: TRetailRegSteps[] = [
    STEP_NAMES.PERSONAL_RETAIL_STEP,
    STEP_NAMES.ADDRESS_RETAIL_STEP,
    STEP_NAMES.PIN_RETAIL_STEP,
    STEP_NAMES.PASSWORD_RETAIL_STEP,
    STEP_NAMES.PREFERENCES_RETAIL_STEP
];

export const RETAIL_REG_ORDERED_OBJECT_STEPS: Record<TRetailRegSteps, number> = {
    [STEP_NAMES.PERSONAL_RETAIL_STEP]: 0,
    [STEP_NAMES.ADDRESS_RETAIL_STEP]: 1,
    [STEP_NAMES.PIN_RETAIL_STEP]: 2,
    [STEP_NAMES.PASSWORD_RETAIL_STEP]: 3,
    [STEP_NAMES.PREFERENCES_RETAIL_STEP]: 4
};
